// include all styles in bundle
import './ui/styles'

import locator from '~/services';
import mount from '~/ui/components/mount';
import TopNav from './ui/components/TopNav';

const components = [
    TopNav,
];

mount(components, locator);
